import styled from '@emotion/styled/macro';

export const DateWrapper = styled.div`
  display: flex;
`;
